import hasIn from 'lodash/hasIn';
import isNaN from 'lodash/isNaN';
import isObject from 'lodash/isObject';
import get from 'lodash/get';
import map from 'lodash/map';
import assign from 'lodash/assign';
import toNumber from 'lodash/toNumber';
import isNumber from 'lodash/isNumber';
import cloneDeep from 'lodash/cloneDeep';
import snakeCase from 'lodash/snakeCase';
import isUndefined from 'lodash/isUndefined';
import {
    configOptions, configKeys, evalueOptions, targetSeqLimitOptions,
} from './constants/constantConfig';
import { createSettingByType, storeLastDefaultAlgorithm } from './constants/settingModel';
import i18n from '../locales/i18n';

import {
    SEARCH_TYPES,
    SEARCH_TYPE,
    SEARCH_TYPE_TO_USER_SETTING_TYPE,
    SEARCH_TYPE_BE_TO_FE,
    SEQUENCE_TYPES,
    DATABASE_TYPES,
    ABST_PROTEIN,
    PROTEIN_DB,
    ABST_NUC,
    MODIFICATION_SEARCH_ALGORITHM_TYPES,
    ScoreMatrixOptions,
} from './constants';
import '@patsnap-ui/icon/assets/solid/info.svg';
import '@patsnap-ui/icon/assets/solid/warning.svg';
import '@patsnap-ui/icon/assets/solid/DropdownOpen.svg';

function rangObject2Array(obj) {
    return [obj.start, obj.end];
}

// 完全废弃，但是留作参考

export default {
    i18n,
    provide() {
        return {
            context: this,
        };
    },
    props: {
    /**
     * 搜索类型 例如：cdr antibody fragment
     */
        searchType: {
            type: String,
            default: SEARCH_TYPE.sequence,
        },
        /**
     * 初始的设置项
     */
        initSetting: {
            type: Object,
            require: true,
            default: () => ({}),
        },
        /**
     * 序列类型
     */
        sequenceType: {
            type: String,
            default: ABST_PROTEIN,
        },
        /**
     * 查询的目标数据类型
     */
        dbType: {
            type: String,
            default: PROTEIN_DB,
        },
        /**
     * 重置的设置项目
     */
        resetSetting: {
            type: Object,
            required: true,
            default: () => ({}),
        },
        /**
     * 解释里的图片移到这里
     */
        images: {
            type: Object,
            default: () => ({}),
        },
        /**
     * 是否需要多选
     */
        radioDbType: {
            type: Boolean,
            default: false,
        },
        /**
     * 是否外部配置db和sequenceType
     */
        externalDbTypeSeqType: {
            type: Boolean,
            default: false,
        },
        /**
     * 是否是在bio里，
     */
        isInBio: {
            type: Boolean,
            default: false,
        },
        /**
     * bio权限
     */
        authority: {
            type: Object,
            default: () => ({}),
        },
        /**
     * 是否显示算法
     */
        isShowAlgorithm: {
            type: Boolean,
            default: true,
        },
    },
    data() {
        const settingConfig = createSettingByType(SEARCH_TYPE_BE_TO_FE[this.searchType]);
        return {
            settingConfig,
            isInit: false,
            evalueOptions,
            algorithmOptions: [],
            targetSeqLimitOptions,
            configOptions,
            SEQUENCE_TYPES,
            DATABASE_TYPES,
        };
    },
    computed: {
        isSlowSearch() {
            return this.settingConfig.sequenceType.value === ABST_PROTEIN
        && (this.isMultiDbType || this.settingConfig.dbType.value === ABST_NUC);
        },
        isMultiDbType() {
            return this.settingConfig.dbType.value === 'ALL';
        },
        multiDbType: {
            get() {
                return this.isMultiDbType ? DATABASE_TYPES : [this.settingConfig.dbType.value];
            },
            set(types) {
                let value = '';
                if (DATABASE_TYPES.every((type) => types.indexOf(type) !== -1)) {
                    value = 'ALL';
                } else {
                    ([value] = types);
                }
                this.settingConfig.dbType.value = value;
                this.updateUserSetting({ key: 'dbType', value });
            },
        },
        transferredSearchType() {
            return SEARCH_TYPE_BE_TO_FE[this.searchType] || this.searchType;
        },
        configOptionsType() {
            const isProteinDb = this.multiDbType[0] === PROTEIN_DB;
            let searchType = this.settingConfig.sequenceType.value;
            if (this.externalDbTypeSeqType) {
                searchType = this.sequenceType;
            }
            if (searchType === ABST_PROTEIN) {
                if (isProteinDb) {
                    return configKeys.protTypeProtDbConfigs;
                }
                return configKeys.protTypeNucDbConfigs;
            }
            if (isProteinDb) {
                return configKeys.nucTypeProtDbConfigs;
            }
            return configKeys.nucTypeNucDbConfigs;
        },
        isShort() {
            return this.transferredSearchType === SEARCH_TYPES.short;
        },
        isMotif() {
            return this.transferredSearchType === SEARCH_TYPES.motif;
        },
        isMotif2() {
            return this.transferredSearchType === SEARCH_TYPES.motif2;
        },
        isSequence() {
            return this.transferredSearchType === SEARCH_TYPES.sequence;
        },
        isFragment() {
            return this.transferredSearchType === SEARCH_TYPES.fragment;
        },
        isAntibody() {
            return this.transferredSearchType === SEARCH_TYPES.antibody;
        },
        isCombined() {
            return this.transferredSearchType === SEARCH_TYPES.combined;
        },
        isCdr() {
            return this.transferredSearchType === SEARCH_TYPES.cdr;
        },
        isModification() {
            return this.transferredSearchType === SEARCH_TYPES.modification;
        },
        settingType() {
            return SEARCH_TYPE_TO_USER_SETTING_TYPE[this.transferredSearchType];
        },
        setting() {
            return this.initSetting;
        },
        evalueOptionsFinal() {
            if (this.isShort) {
                return evalueOptions.filter((x) => x.value >= 0.1);
            }
            return evalueOptions;
        },
        targetSeqLimitOptionsFinal() {
            return map(targetSeqLimitOptions, (opt) => assign(
                { ...opt },
                opt.value === 50000 && !this.authority.isVIP
                    ? {
                        disabled: true,
                        tooltip: this.$tc(
                            'Search.labels.targetSeqLimitTooltip',
                        ),
                    }
                    : {},
            ));
        },
        MODIFICATION_SEARCH_ALGORITHM_TYPES() {
            return MODIFICATION_SEARCH_ALGORITHM_TYPES;
        },
        isNWAlgorithmType() {
            return this.isActive(this.settingConfig.algorithmType)
        && this.settingConfig.algorithmType.value === MODIFICATION_SEARCH_ALGORITHM_TYPES.NW;
        },
        ScoreMatrixOptions() {
            return ScoreMatrixOptions;
        },
    },
    watch: {
        dbType(value) {
            if (this.externalDbTypeSeqType) {
                this.settingConfig.dbType.value = value;
                this.setRelatedItems();
            }
        },
        sequenceType(value) {
            if (this.externalDbTypeSeqType) {
                this.settingConfig.sequenceType.value = value;
                this.setRelatedItems();
            }
        },
        initSetting(to, from) {
            if (to !== from) {
                this.assignSettingConfigValue(to);
            }
        },
    },
    created() {
        this.assignSettingConfigValue(this.initSetting);
        if (this.settingConfig.setAlgorithm) {
            this.settingConfig.setAlgorithm(this.configOptionsType);
        }
        this.isInit = true;
    },
    methods: {
        safeImagesUrl(name) {
            const imgs = {
                similarityExplanation: this.images?.similarityExplanation,
                ungappedExplanation: this.images?.ungappedExplanation,
                globalAlignmentExplanation: this.images?.globalAlignmentExplanation,
                globalAlignmentSimilarityExplanation: this.images?.globalAlignmentSimilarityExplanation,
            };
            return get(imgs, name);
        },
        isNumber(ev) {
            const charCode = ev.keyCode;
            // char code 48 对应 0， char code 57 对应 9， > 31 表示可显示字符
            if (charCode > 31 && (charCode < 48 || charCode > 57) && charCode !== 46) {
                ev.preventDefault();
            }
            return true;
        },
        onStartChange(e) {
            let value = toNumber(e.target.value);
            if (isNaN(value)
        || (value > this.settingConfig.sequenceLength.value[1]
          && this.settingConfig.sequenceLength.value[1])
        || value < 0) {
                value = 0;
            }
            this.settingConfig.sequenceLength.value[0] = value;
            this.updateUserSetting({
                key: 'subject_length',
                value: this.arrayToObject(this.settingConfig.sequenceLength.value),
            });
        },
        onEndChange(e) {
            let value = toNumber(e.target.value);
            if (isNaN(value) || value < this.settingConfig.sequenceLength[0]) {
                value = '';
            }
            this.settingConfig.sequenceLength.value[1] = value || '';
            this.updateUserSetting({
                key: 'subject_length',
                value: this.arrayToObject(this.settingConfig.sequenceLength.value),
            });
        },
        updateMultiSubjectLength(multiSubject) {
            const { protein, nucleotide } = multiSubject;
            this.updateUserSetting({
                key: 'multi_subject_length',
                value: {
                    protein: {
                        start: get(protein, '[0]', 0),
                        end: get(protein, '[1]', ''),
                    },
                    nucleotide: {
                        start: get(nucleotide, '[0]', 0),
                        end: get(nucleotide, '[1]', ''),
                    },
                },
            });
        },
        onMultiProteinStartChange(e) {
            let value = toNumber(e.target.value);
            if (isNaN(value)
        || (value > this.settingConfig.multiSequenceLength.value.protein[1]
          && this.settingConfig.multiSequenceLength.value.protein[1])
        || value < 0) {
                value = 0;
            }
            this.settingConfig.multiSequenceLength.value.protein[0] = value;
            this.updateMultiSubjectLength(this.settingConfig.multiSequenceLength.value);
        },
        onMultiProteinEndChange(e) {
            let value = toNumber(e.target.value);
            if (isNaN(value) || value < this.settingConfig.multiSequenceLength.value.protein[0]) {
                value = '';
            }
            this.settingConfig.multiSequenceLength.value.protein[1] = value || '';
            this.updateMultiSubjectLength(this.settingConfig.multiSequenceLength.value);
        },
        onMultiNucStartChange(e) {
            let value = toNumber(e.target.value);
            if (isNaN(value)
        || (value > this.settingConfig.multiSequenceLength.nucleotide[1]
          && this.settingConfig.multiSequenceLength.value.nucleotide[1])
        || value < 0) {
                value = 0;
            }
            this.settingConfig.multiSequenceLength.value.nucleotide[0] = value;
            this.updateMultiSubjectLength(this.settingConfig.multiSequenceLength.value);
        },
        onMultiNucEndChange(e) {
            let value = toNumber(e.target.value);
            if (isNaN(value) || value < this.settingConfig.multiSequenceLength.value.nucleotide[0]) {
                value = '';
            }
            this.settingConfig.multiSequenceLength.value.nucleotide[1] = value || '';
            this.updateMultiSubjectLength(this.settingConfig.multiSequenceLength.value);
        },
        resetPreferenceSet() {
            this.updateUserSetting({ key: 'perc_identity', value: this.resetSetting.perc_identity });
            this.updateUserSetting({ key: 'q_perc_identity', value: this.resetSetting.q_perc_identity });
            this.updateUserSetting({ key: 'qcov_hsp_perc', value: this.resetSetting.qcov_hsp_perc });
            this.updateUserSetting({ key: 's_perc_identity', value: this.resetSetting.s_perc_identity });
            this.updateUserSetting({ key: 'scov_hsp_perc', value: this.resetSetting.scov_hsp_perc });
            this.updateUserSetting({ key: 'subject_length', value: this.resetSetting.subject_length });
            this.updateUserSetting({ key: 'multi_subject_length', value: this.resetSetting.multi_subject_length });
            this.updateUserSetting({ key: 'evalue', value: this.resetSetting.evalue });
            this.updateUserSetting({ key: 'ungapped', value: this.resetSetting.ungapped });
            this.updateUserSetting({ key: 'sequenceType', value: this.resetSetting.sequenceType });
            this.updateUserSetting({ key: 'dbType', value: this.resetSetting.dbType });
            this.updateUserSetting({ key: 'mismatches', value: cloneDeep(this.resetSetting.mismatches) });
            this.updateUserSetting({ key: 'algorithm_type', value: this.resetSetting.algorithmType });
            this.updateUserSetting({ key: 'gap_extend', value: this.resetSetting.gapExtend });
            this.updateUserSetting({ key: 'gap_open', value: this.resetSetting.gapOpen });
            this.updateUserSetting({ key: 'score_matrix', value: this.resetSetting.scoreMatrix });
            this.assignSettingConfigValue(this.resetSetting);
            if (this.settingConfig.setAlgorithm) {
                this.settingConfig.setAlgorithm(this.configOptionsType);
            }
            this.$emit('updateSetting', { key: 'algorithmSettings', value: this.wrapAlgorithmSettings() });
            /**
       * 重置设置项
       */
            this.$emit('reset');
        },
        arrayToObject(arr) {
            return {
                start: get(arr, '[0]'),
                end: get(arr, '[1]'),
            };
        },
        updateUserSetting(payload) {
            /**
       * 更新设置项
       */
            this.$emit('updateSetting', payload, this.setting);
        },
        updateSequenceType(e) {
            this.setRelatedItems();
            this.updateUserSetting({ key: 'sequenceType', value: e.target.value });
            if (this.isMotif) {
                this.settingConfig.dbType.value = this.settingConfig.sequenceType.value === ABST_PROTEIN
                    ? this.DATABASE_TYPES[1]
                    : this.DATABASE_TYPES[0];
                this.updateUserSetting({ key: 'dbType', value: this.settingConfig.dbType.value });
            }
        },
        updateDbType(e) {
            let { value } = e.target;
            this.$nextTick(() => {
                if ((this.isSequence || this.isShort) && !this.radioDbType) {
                    if (DATABASE_TYPES.every((type) => this.multiDbType.indexOf(type) !== -1)) {
                        value = 'ALL';
                    } else {
                        ([value] = this.multiDbType);
                    }
                }
                this.setRelatedItems();
                this.updateUserSetting({ key: 'dbType', value });
            });
        },
        handleChangeMultipleDbType() {
            this.setRelatedItems();
        },
        setRelatedItems() {
            if (this.settingConfig.setAlgorithm) {
                // 还原
                if (storeLastDefaultAlgorithm.isStore && this.settingConfig.defaultAlgorithm) {
                    this.settingConfig.defaultAlgorithm.value = storeLastDefaultAlgorithm.value;
                    storeLastDefaultAlgorithm.isStore = false;
                }
                this.settingConfig.setAlgorithm(this.configOptionsType, true);
            }
            if (this.settingConfig.setLowComplexRegion) {
                this.settingConfig.setLowComplexRegion(this.configOptionsType);
            }
            this.handleAlgorithmFieldsChange();
        },
        assignSettingConfigValue(setting) {
            const st = this.settingConfig;
            Object.keys(st).forEach((k) => {
                if (st[k] && isObject(st[k]) && !Object.isFrozen(st[k])) {
                    if (hasIn(setting, st[k].key)) {
                        st[k].value = get(setting, st[k].key);
                    }
                    if (hasIn(setting.algorithmSettings, st[k].key)
            || hasIn(setting.algorithmSettings, snakeCase(st[k].key))) {
                        st[k].value = get(setting.algorithmSettings, st[k].key);
                        if (isUndefined(st[k].value)) {
                            get(setting.algorithmSettings, snakeCase(st[k].key));
                        }
                        // 后端会返回数字类型，全部转成字符串
                        if (isNumber(st[k].value)) {
                            st[k].value = String(st[k].value);
                        }
                    }
                }
            });

            if (this.externalDbTypeSeqType) {
                this.settingConfig.sequenceType.value = this.sequenceType;
                this.settingConfig.dbType.value = this.dbType;
            } else {
                this.settingConfig.sequenceType.value = setting.sequenceType;
                this.settingConfig.dbType.value = setting.dbType;
            }

            if (st.similarity) {
                st.similarity.value = rangObject2Array(get(setting, st.similarity.key, {}));
            }
            if (st.querySimilarity) {
                st.querySimilarity.value = rangObject2Array(get(setting, st.querySimilarity.key, {}));
            }
            if (st.queryCoverage) {
                st.queryCoverage.value = rangObject2Array(get(setting, st.queryCoverage.key, {}));
            }
            if (st.subjectSimilarity) {
                st.subjectSimilarity.value = rangObject2Array(get(setting, st.subjectSimilarity.key, {}));
            }
            if (st.subjectCoverage) {
                st.subjectCoverage.value = rangObject2Array(get(setting, st.subjectCoverage.key, {}));
            }
            if (st.sequenceLength) {
                st.sequenceLength.value = rangObject2Array(get(setting, st.sequenceLength.key, { start: 0, end: '' }));
            }
            if (st.multiSequenceLength) {
                const { protein = {}, nucleotide = {} } = get(setting, 'multi_subject_length', {});
                st.multiSequenceLength.value = {
                    protein: [protein.start || 0, protein.end || ''],
                    nucleotide: [nucleotide.start || 0, nucleotide.end || ''],
                };
            }
        },
        handleMismatch(value, index) {
            this.settingConfig.mismatches.value[index].value = value;
            this.updateUserSetting({ key: 'mismatches', value: this.settingConfig.mismatches.value });
        },
        isActive(field) {
            return field && field.active;
        },
        wrapAlgorithmSettings() {
            // 同时查询多个db，不返回算法
            if (this.isMultiDbType) {
                return undefined;
            }
            const algorithmSettings = {};
            if (this.settingConfig.algorithm) {
                algorithmSettings.algorithm = this.settingConfig.algorithm.value;
            }
            if (this.settingConfig.defaultAlgorithm) {
                algorithmSettings.automatic = this.settingConfig.defaultAlgorithm.value;
            }
            if (this.settingConfig.gaps) {
                algorithmSettings.gaps = this.settingConfig.gaps.value;
            }
            if (this.settingConfig.lowComplexRegion) {
                algorithmSettings.low_complexity_region = this.settingConfig.lowComplexRegion.value;
            }
            if (this.settingConfig.matchScores) {
                algorithmSettings.matchScores = this.settingConfig.matchScores.value;
            }
            if (this.settingConfig.matrix) {
                algorithmSettings.matrix = this.settingConfig.matrix.value;
            }
            if (this.settingConfig.wordSize) {
                algorithmSettings.wordSize = this.settingConfig.wordSize.value;
            }
            return algorithmSettings;
        },
        handleAlgorithmChange(field) {
            if (this.settingConfig.setAlgorithm) {
                this.settingConfig.setAlgorithm(this.configOptionsType, true);
            }
            this.handleAlgorithmFieldsChange(field);
        },
        handleAlgorithmFieldsChange(field) {
            this.$emit('updateSetting', { key: 'algorithmSettings', value: this.wrapAlgorithmSettings() });
            if (field) {
                this.$emit('updateAlgorithm', { key: field.key, value: field.value });
            }
        },
        handelFieldChange(field, toObject) {
            this.updateUserSetting({
                key: field.key,
                value: toObject ? this.arrayToObject(field.value) : field.value,
            });
        },
        handleChangeMatrix() {
            this.settingConfig.setGapCostOptions(this.configOptionsType, true);
            this.handleAlgorithmFieldsChange(this.settingConfig.matrix);
        },
        handleChangeMatchScores() {
            this.settingConfig.setGapCostOptions(this.configOptionsType, true);
            this.handleAlgorithmFieldsChange(this.settingConfig.matchScores);
        },
    },
};
